<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/couponmerchantselect/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="终端类型">
        <el-select clearable v-model="formModel.acctType">
          <el-option
            v-for="item in acctTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div class="flex-row vertical-center flow-wrap" v-show="isAcctype">
        <el-form-item label="用户ID">
          <el-input
            v-model="formModel.merchantNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item label="用户手机号">
          <el-input
            v-model="formModel.merPhone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flex-row vertical-center flow-wrap" v-show="!isAcctype">
        <el-form-item label="商户号">
          <el-input
            v-model="formModel.merchantNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户姓名">
          <el-input
            v-model="formModel.realName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户手机号">
          <el-input
            v-model="formModel.merPhone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input v-model="formModel.merName" placeholder="请输入"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="天狮ID" prop="tsId">
        <el-input
          type="text"
          maxlength="100"
          v-model="formModel.tsId"
          placeholder="请输入"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="交易订单号">
        <el-input
          style="width: 250px"
          v-model="formModel.orderNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select clearable v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="优惠券组">
        <el-select clearable v-model="formModel.groupId">
          <el-option
            v-for="item in groupId"
            :key="item.id"
            :label="item.groupName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发放时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="使用时间">
        <el-date-picker
          v-model="formModel.time1"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="acctType"
        label="终端类型"
        :formatter="formatterTableAcctype"
        min-width="230"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
        v-if="!isAcctype"
      ></el-table-column>
      <el-table-column
        prop="realName"
        :label="isAcctype ? '用户名称' : '商户姓名'"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merNo"
        :label="isAcctype ? '用户id' : '商户号'"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merPhone"
        :label="isAcctype ? '用户手机号' : '商户手机号'"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tsId"
        label="天狮ID"
        :formatter="formatterTableData"
        min-width="230"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="groupName"
        label="优惠券组名"
        :formatter="formatterTableData"
        min-width="230"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="couponAmt"
        label="面值(元)"
        :formatter="formatterTableNumberYuan"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tranAmt"
        label="交易金额(元)"
        :formatter="formatterTableNumberYuan"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="使用期限"
        :formatter="formatterTableData"
        min-width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.createTime }}<span> ~ </span>{{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="modifier"
        label="发放人"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sendTime"
        label="发放时间"
        :formatter="formatterTableData"
        min-width="200"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatterTablestatus"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderNo"
        label="交易订单号"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="useTime"
        label="使用时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>

      <el-table-column
        prop="duseTime"
        label="待使用时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column label="操作" min-width="260" fixed="right">
        <template slot-scope="scope">
             <div style="display: flex; justify-content: center">
          <el-button type="text" @click="handleUse(scope.row)"
            >{{ scope.row.status == 0 ? "待使用" : "/" }}
          </el-button>
           <el-button type="text" @click="handleDelete(scope.row)"
              >删除
            </el-button>
            </div>
        </template>
        
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TimeRange from "service/constant/TimeRange";

import TransactionService from "service/TransactionService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "couponmerchantselect",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        tsId: "",
        merName: "",
        merchantNo: "",
        merPhone: "",
        realName: "",
        status: "",
        groupId: "",
        acctType: "7",
        time: "", //发放
        time1: "", //使用
      },
      tableData: [],
      status: [{ id: "", value: "全部" }],
      groupId: [{ id: "", groupName: "全部" }],
      submitService: TransactionService.couponmerchantselectList,
      params: {},
      page: {},
      isPage: false,
      acctTypes: [
        {
          dictKey: "7",
          dictValue: "个人版",
        },
        {
          dictKey: "9",
          dictValue: "商户端",
        },
      ],
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    isAcctype() {
      return this.formModel.acctType == "7";
    },
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = []; //发放
      }
      if (this.formModel.time1 == null || this.formModel.time1 == "") {
        this.formModel.time1 = []; //使用
      }
      const params = {
        tsId: this.formModel.tsId,
        merName: this.formModel.merName,
        merchantNo: this.formModel.merchantNo,
        merPhone: this.formModel.merPhone,
        realName: this.formModel.realName,
        status: this.formModel.status,
        groupId: this.formModel.groupId,
        orderNo: this.formModel.orderNo,
        acctType: this.formModel.acctType,

        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.sendTimeStart = this.formModel.time[0]; //发放
        params.sendTimeEnd = this.formModel.time[1];
      }
      if (this.formModel.time1.length) {
        params.useTimeStart = this.formModel.time1[0]; //使用
        params.useTimeEnd = this.formModel.time1[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  watch: {
    "formModel.acctType"(val, oldVal) {
      if (this.tableData.length > 0) {
        this.$data.tableData = [];
        this.page.currentPage = 1;
        this.page.total = 0;
      }
    },
  },
  methods: {
       handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
       doDelete(id) {
      this.doLoad(
        TransactionService.deleteData,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
     commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    load() {
      this.formModel = {
        status: "",
        groupId: "",
        time: "",
        time1: "",
        acctType: "7",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getStatus();
      this.getGroupId();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getStatus() {
      //状态
      this.doLoad(
        TransactionService.couponmerchantselectStatus,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.status = [...this.status, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    getGroupId() {
      //优惠卷组
      this.doLoad(
        TransactionService.coupongroupmanageList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.groupId = [...this.groupId, ...res.contents.rows];
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleUse(item) {
      const _this = this;
      if (item.status != 0) {
        return;
      }
      this.showConfirm("确认修改该条状态？").then(() => {
        _this.doLoad(
          TransactionService.CouponGroupupdateById,
          {
            id: item.id,
          },
          (res) => {
            this.showSuccess(res.respMsg);
            this.getList();
          },
          "信息获取失败"
        );
      });
    },
    formatterTablestatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.id == cellValue) {
          value = item.value;
        }
      });
      return value;
    },
    formatterTableAcctype(row, column, cellValue, index) {
      let value = "--";
      this.acctTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/CouponMerchantSelect.vue